import { FaArrowDownLong } from "react-icons/fa6";

import classes from "./Order.module.css";
import { formatDate, formatAmount } from "../../util/helpers";

export default function OrderDetails({ shipment }) {
  return (
    <div className={classes.container}>
      <h2>RECIPIENT INFO</h2>
      <div className={classes.order}>
        <div className={classes.personal}>
          <div className={classes.content}>
            <span className={classes.title}>Address</span>
            <span className={classes.value}>{shipment.address}</span>
          </div>
          <div className={classes.content}>
            <span className={classes.title}>Recipient</span>
            <span className={classes.value}>{shipment.recipient}</span>
          </div>
          <div className={classes.content}>
            <span className={classes.title}>Email</span>
            <span className={classes.value}>{shipment.email}</span>
          </div>
        </div>
        <h2>ITEMS</h2>
        <div className={classes.heading}>
          <div className={classes.desc}>
            <span className={classes.title}>Name</span>
            <span className={classes.value}>Description</span>
          </div>
          <span className={classes.title}>Quantity</span>
          <span className={classes.title}>Price</span>
        </div>
        {shipment.items.map((item, index) => (
          <div className={classes.heading} key={index}>
            <div className={classes.desc}>
              <span className={classes.title}>{item.name}</span>
              <span className={classes.value}>{item.desc}</span>
            </div>
            <span className={classes.title}>{item.quantity}</span>
            <span className={classes.title}>${formatAmount(item.price)}</span>
          </div>
        ))}
      </div>
      <div className={classes.heading}>
        <span className={classes.title}>TOTAL</span>
        <span className={classes.title}>
          {shipment.items
            .map((item) => item.quantity)
            .reduce((acc, cur) => acc + cur, 0)}
        </span>
        <span className={classes.title}>
          $
          {formatAmount(
            shipment.items
              .map((item) => item.price * item.quantity)
              .reduce((acc, cur) => acc + cur, 0)
          )}
        </span>
      </div>
      <h2>TRACKING INFO</h2>
      <div className={classes.locations}>
        {shipment.locations.map((loc, index) => (
          <div className={classes.loc} key={index}>
            <div className={classes.info}>
              <span className={classes.message}>{loc.desc}</span>
              <span className={classes.time}>{formatDate(loc.date)}</span>
              <span className={classes.instruction}>{loc.instruction}</span>
            </div>
            {index !== shipment.locations.length - 1 && (
              <FaArrowDownLong className={classes.icon} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
